import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";

export const getEmojiMartV5Data = () =>
  reactQueryGet("https://d1d0f0u7zob9x2.cloudfront.net/emoji-set-v3.json");
